import { 
    LOAD_LIST_ENTERPRISE, LOAD_A_ENTERPRISE, ADD_NEW_ENTERPRISE, UPDATE_A_ENTERPRISE, 
    DELETE_A_ENTERPRISE, CLEAR_A_ENTERPRISE_DETAIL, CLEAR_ENTERPRISE_ACTION_STATUS
} from '../actionTypes';
import { SUCCESS_STATUS, FAILED_STATUS } from '../../constants';

const initialState = {
    enterpriseList: [],
    enterpriseDetail: null,
    loading: false,
    error: '',
    actionStatus: undefined,
    actionMsg: ""
};

export default function(state = initialState, action) {
    switch(action.type) {
        case LOAD_LIST_ENTERPRISE: {
            return {
                ...state,
                enterpriseList: action.payload,
            }
        }

        case LOAD_A_ENTERPRISE: {
            return {
                ...state,
                enterpriseDetail: action.payload
            }
        }

        case ADD_NEW_ENTERPRISE: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                enterpriseList: [
                    action.payload.data,
                    ...state.enterpriseList
                ],
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case UPDATE_A_ENTERPRISE: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                enterpriseList: state.enterpriseList.map(item => item.id !== action.payload.data.id ? item : action.payload.data),
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case DELETE_A_ENTERPRISE: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }
            
            return {
                ...state,
                loading: false,
                enterpriseList: state.enterpriseList.filter(item => item.id !== parseFloat(action.payload.data)),
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case CLEAR_A_ENTERPRISE_DETAIL: {
            return {
                ...state,
                enterpriseDetail: null,
            }
        }

        case CLEAR_ENTERPRISE_ACTION_STATUS: {
            return {
                ...state,
                actionStatus: undefined,
                actionMsg: ""
            }
        }

        default:
            return state
    }
}